import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import styles from '../styles/file-uploader.less';
import { STATUS_COMPRESSING, STATUS_UPLOADING, STATUS_DONE, STATUS_ERROR } from './compressFile';
import { prettyBytes } from '../utils/prettyBytes';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('Cleaner');
function typeToPill(type) {
  var modeToVariant = {
    'null': 'light',
    'bool': 'light',
    'binary': 'light',
    'int': 'primary',
    'float': 'secondary',
    'time': 'success',
    'string': 'info',
    'object': 'info',
    'unknown': 'warning',
    'error': 'danger'
  };
  var mode;
  switch (type) {
    case 'null':
      mode = 'null';
      break;
    case 'object':
      mode = 'object';
      break;
    case 'bool_':
      mode = 'bool';
      break;
    case 'int8':
    case 'int16':
    case 'int32':
    case 'int64':
      mode = 'int';
      break;
    case 'uint8':
    case 'uint16':
    case 'uint32':
    case 'uint64':
      mode = 'int';
      break;
    case 'float8':
    case 'float16':
    case 'float32':
    case 'float64':
      mode = 'float';
      break;
    case 'time32':
    case 'time64':
    case 'timestamp':
    case 'date32':
    case 'date64':
      mode = 'time';
      break;
    case 'binary':
    case 'large_binary':
      mode = 'binary';
      break;
    case 'string':
    case 'utf8':
    case 'large_string':
    case 'large_utf8':
      mode = 'string';
      break;
    case 'decimal128':
    case 'list_':
    case 'large_list':
    case 'map_':
    case 'struct':
    case 'dictionary':
      mode = 'unknown';
      break;
    default:
      mode = 'error';
      break;
  }
  return /*#__PURE__*/_jsx(Badge, {
    variant: modeToVariant[mode],
    children: type
  });
}
function prettyPrintParseErrors(errors) {
  if (!errors) {
    return 'Unknown parsing errors after upload; please contact staff';
  }
  var code = errors.code,
    message = errors.message,
    data = errors.data;
  if (!message && !data) {
    log.error({
      errors: errors
    }, 'Unexpected format for parse errors');
    try {
      return "Unknown error (".concat(code, "): ").concat(JSON.stringify(errors));
    } catch (e) {
      return "Unknown error (".concat(code, ")");
    }
  }
  var msg = "Error".concat(code ? " (".concat(code, "): ") : ': ').concat(message ? message + ' ' : '');
  if (data) {
    try {
      msg += ' :: ' + JSON.stringify(data);
    } catch (e) {
      log.error({
        msg: msg,
        e: e
      }, 'Failed pretty printing uploader parse error');
    }
  }
  return msg;
}
export function Cleaner(_ref) {
  var visible = _ref.visible,
    user = _ref.user,
    files = _ref.files,
    setFiles = _ref.setFiles;
  if (!visible) {
    return null;
  }
  log.debug({
    user: user,
    files: files
  }, 'Cleaner');
  if (!files || !files.length) {
    return /*#__PURE__*/_jsx("div", {
      className: styles['cleaner'],
      children: "No files available yet. First go back and upload some."
    });
  }
  var header = /*#__PURE__*/_jsx("h5", {
    className: styles['dropper-instr-header'],
    children: "Check uploaded files. If any contain issues, go back and reupload fixed versions."
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles['cleaner'],
    children: [header, /*#__PURE__*/_jsx("hr", {}), (files || []).map(function (_ref2, i) {
      var name = _ref2.name,
        status = _ref2.status,
        sizeCompressedBytes = _ref2.sizeCompressedBytes,
        fileStats = _ref2.fileStats,
        error = _ref2.error;
      var _ref4 = fileStats || {},
        _ref4$tables_schemas = _ref4.tables_schemas,
        tables_schemas = _ref4$tables_schemas === void 0 ? [] : _ref4$tables_schemas,
        is_uploaded = _ref4.is_uploaded,
        is_valid = _ref4.is_valid;
      var errors = (fileStats || {}).errors || ((fileStats || {}).data || {}).errors;
      var fileHeader = /*#__PURE__*/_jsxs("h5", {
        className: styles['cleaner-file-name'],
        children: [/*#__PURE__*/_jsx("i", {
          className: "fa fa-file"
        }), /*#__PURE__*/_jsxs("span", {
          children: ["File ", name, " ", sizeCompressedBytes ? "(".concat(prettyBytes(sizeCompressedBytes), ")") : null]
        })]
      });
      function wrapBody(body) {
        return /*#__PURE__*/_jsxs("div", {
          className: styles['cleaner-file'],
          children: [fileHeader, body]
        }, "key-".concat(i));
      }
      switch (status) {
        case STATUS_COMPRESSING:
          return wrapBody(/*#__PURE__*/_jsx("div", {
            className: "".concat(styles['cleaner-file'], " ").concat(styles['cleaner-file-compressing']),
            children: "Compressing"
          }));
        case STATUS_UPLOADING:
          return wrapBody(/*#__PURE__*/_jsx("div", {
            className: "".concat(styles['cleaner-file'], " ").concat(styles['cleaner-file-uploading']),
            children: "Uploading"
          }));
        case STATUS_ERROR:
          return wrapBody(/*#__PURE__*/_jsxs("div", {
            className: "".concat(styles['cleaner-file'], " ").concat(styles['cleaner-file-error'], " text-danger"),
            children: ["Error: ", error]
          }));
        case STATUS_DONE:
          //below rendering code
          break;
        default:
          return wrapBody(/*#__PURE__*/_jsxs("div", {
            className: "".concat(styles['cleaner-file'], " ").concat(styles['cleaner-file-error']),
            children: ["Unknown status ", status]
          }));
      }
      if (!is_uploaded) {
        return wrapBody(/*#__PURE__*/_jsx("div", {
          className: styles['cleaner-file-error'],
          children: "File not yet uploaded. Likely an error when encountered through this form, please contact staff."
        }));
      }
      if (!is_valid) {
        log.debug({
          errors: errors
        }, 'Clearner showing error');
        return wrapBody(/*#__PURE__*/_jsxs("div", {
          className: "".concat(styles['cleaner-file-error'], " text-danger"),
          children: ["File uploaded but could not be understood. Fix and upload again:", /*#__PURE__*/_jsx("pre", {
            children: prettyPrintParseErrors(errors)
          })]
        }));
      }
      return /*#__PURE__*/_jsxs("div", {
        className: styles['cleaner-file'],
        children: [fileHeader, !tables_schemas.length ? /*#__PURE__*/_jsx("p", {
          children: "No tables detected: Reformat the file or use different settings"
        }) : null, /*#__PURE__*/_jsx("div", {
          className: styles['cleaner-file-tables'],
          children: tables_schemas.map(function (_ref3, tableIndex) {
            var dtypes = _ref3.dtypes,
              name = _ref3.name,
              num_cols = _ref3.num_cols,
              num_rows = _ref3.num_rows;
            var tableHeader = /*#__PURE__*/_jsxs(Card.Header, {
              className: "".concat(styles['cleaner-table'], " bg-light text-dark font-weight-bold"),
              children: [/*#__PURE__*/_jsx("i", {
                className: "fa fa-table"
              }), /*#__PURE__*/_jsxs("span", {
                children: ["Table ", name, " ( ", num_rows, " rows x ", num_cols, " columns)"]
              })]
            });
            if (!Object.keys(dtypes).length) {
              return /*#__PURE__*/_jsxs(Card, {
                children: [tableHeader, /*#__PURE__*/_jsx(Card.Body, {
                  className: styles['cleaner-columns'],
                  children: "No table columns detected."
                })]
              }, "k-".concat(tableIndex));
            }
            return /*#__PURE__*/_jsxs(Card, {
              children: [tableHeader, /*#__PURE__*/_jsxs(Card.Body, {
                className: "".concat(styles['cleaner-columns'], " bg-light"),
                children: [Object.keys(dtypes).length === 1 ? 'Only 1 column detected' : null, /*#__PURE__*/_jsxs(Table, {
                  className: "bg-white",
                  children: [/*#__PURE__*/_jsx("thead", {
                    className: "bg-white text-dark",
                    children: /*#__PURE__*/_jsx("tr", {
                      children: Object.keys(dtypes || {}).map(function (colName, i) {
                        return /*#__PURE__*/_jsx("th", {
                          children: colName
                        }, "k-".concat(i));
                      })
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: /*#__PURE__*/_jsx("tr", {
                      children: Object.values(dtypes || {}).map(function (colType, i) {
                        return /*#__PURE__*/_jsx("td", {
                          children: typeToPill(colType)
                        }, "k-".concat(i));
                      })
                    })
                  })]
                })]
              })]
            }, "k-".concat(tableIndex));
          })
        })]
      }, "k-".concat(i));
    })]
  });
}